import * as React from 'react';
import { Component, forwardRef, createRef } from 'react';
import { findDOMNode } from 'react-dom';
import SpatialNavigationWrapper from './SpatialNavigationWrapper';

export class FocusableParent extends Component {
  sectionId;
  parentRef;
  constructor(props) {
    super(props);

    this.parentRef = props.forwardedRef || createRef();
    this.sectionId = '';
  }

  componentDidMount() {
    this.sectionId = this.addFocusable();

    if (this.parentRef.current) {
      this.parentRef.current.addEventListener('sn:unfocused', this.onLeave);
    }
  }

  componentWillUnmount() {
    if (this.parentRef.current) {
      this.parentRef.current.removeEventListener('sn:unfocused', this.onLeave);
    }
    FocusableParent.removeFocusable(this.sectionId);
  }

  onLeave = (data) => {
    const { onLeave } = this.props;
    const { nextSectionId } = data.detail;
    if (nextSectionId !== this.sectionId && onLeave) onLeave(nextSectionId);
  };

  addFocusable() {
    const { config, defaultSection, sectionName, id } = this.props;
    const ref = this.parentRef;
    const domNode = findDOMNode(ref.current);

    return SpatialNavigationWrapper.addFocusable(domNode, {
      config,
      defaultSection,
      id,
      sectionName,
    });
  }

  static removeFocusable(sectionId) {
    SpatialNavigationWrapper.removeFocusable(sectionId);
  }

  render() {
    const { className, children, id, onClick, onFocus, onMouseMove, onMouseEnter, onMouseLeave, style } = this.props;
    return (
      <div
        className={className}
        id={id}
        ref={this.parentRef}
        onClick={onClick}
        onFocus={onFocus}
        onMouseMove={onMouseMove}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={style}
      >
        {children}
      </div>
    );
  }
}

export default forwardRef((props, ref) => <FocusableParent forwardedRef={ref} {...props} />);
